<div class="background">
  <div class="modal-card">
    <span class="material-symbols-rounded icon"> error </span>
    <div class="absolute top-2/4 -translate-y-1/2 justify-center text-center">
      <h1 class="font-bold mt-5">
        {{ title ?? "home.confirmModal.title" | translate }}
      </h1>
      <p class="message">{{ message }}</p>
    </div>

    <div class="actions">
      @if (isSingleAction) {
        <button (click)="onClose()" class="cancel">
          {{ "home.confirmModal.close" | translate }}
        </button>
      } @else {
        <button (click)="onCancel()" class="cancel">
          {{ "home.confirmModal.cancel" | translate }}
        </button>
        <button (click)="onConfirm()" class="confirm">
          {{ "home.confirmModal.confirm" | translate }}
        </button>
      }
    </div>
  </div>
</div>
